import { useEffect, useContext, useState } from "react";
import { DatabaseValue } from "../contexts/database";
import styles from "./styles.module.css";
import Checkbox from "../checkbox";

export default function FieldSelect({ value, onChange, params }) {
  const [_value, setValue] = useState({ fields: { _id: true } });
  const [table, setTable] = useState("");
  const tables = useContext(DatabaseValue);
  const [tableSchema, setTableSchema] = useState(null);
  useEffect(() => {
    if (value) {
      setValue(value);
    } else {
      setValue({ table: params.type, fields: { _id: true } });
    }
  }, [value]);

  useEffect(() => {
    const _table = tables.find((x) => x.id === params.type);
    if (_table) {
      setTableSchema(_table.fields);
      setTable(_table.id);
    }
  }, [params.type]);

  const handleCheck = (value, key) => {
    const Value = { ..._value };
    const _table = tables.find((x) => x.id === tableSchema[key].type);
    if (_table && value === true) {
      Value.fields[key] = { table: _table.id, fields: { _id: true } };
    } else {
      Value.fields[key] = value;
    }
    Value.table = table;
    setValue(Value);
    onChange(Value);
  };

  if (!tableSchema) {
    return null;
  }
  return (
    <div className={styles.fieldSelect}>
      {Object.keys(tableSchema)
        .sort((key1, key2) => {
          if (tableSchema[key1].name > tableSchema[key2].name) {
            return 1;
          }
          return -1;
        })
        .filter((x) => x !== "_id")
        .map((key) => {
          return (
            <SelectItem
              selected={_value.fields[key]}
              key={key}
              field={tableSchema[key]}
              onChange={(value) => handleCheck(value, key)}
            />
          );
        })}
    </div>
  );
}

const SelectItem = ({ field, selected, onChange }) => {
  return (
    <>
      <div className={styles.selectItem}>
        <Checkbox
          style={{ marginRight: 4 }}
          onChange={onChange}
          checked={selected}
        />
        {field.name}
      </div>
      {typeof selected === "object" && (
        <div style={{ paddingLeft: 8 }}>
          <FieldSelect
            value={selected}
            onChange={(value) => onChange(value)}
            params={{ type: selected.table }}
          />
        </div>
      )}
    </>
  );
};
